<template>
<div class="badge" v-bind:class="{'badge--error': isError, 'badge--disabled': isDisabled}">
    <span class="badge__text">{{text}}</span>
    <span class="badge__close">
        <img src="../../assets/images/close-white.svg">
    </span>
</div>
</template>

<script>
export default {
    name: "UXBadge",
    props: {
        text: String,
        isError: Boolean,
        isDisabled: Boolean
    },
    computed: {}
};
</script>
